import { stopInactivityLogout } from "./inactivityService";

// Install before rendering so all authenticated pages share this behavior.
export function startCrossTabLogout({
  navigate = () => window.location.replace("/"),
} = {}) {
  const hadSession = !!localStorage.getItem("token");
  let redirecting = false;

  const leaveSession = () => {
    if (!hadSession || redirecting) return;
    redirecting = true;
    stopInactivityLogout();
    // A full navigation also discards cached auth headers and page timers.
    // The initiating tab already cleared storage and reported the logout.
    navigate();
  };

  const onStorage = (event) => {
    if (event.storageArea !== localStorage) return;
    if (event.key === null || (event.key === "token" && event.newValue === null)) {
      leaveSession();
    }
  };
  const checkSession = () => {
    if (!localStorage.getItem("token")) leaveSession();
  };
  const onVisibility = () => {
    if (document.visibilityState === "visible") checkSession();
  };

  window.addEventListener("storage", onStorage);
  window.addEventListener("focus", checkSession);
  window.addEventListener("pageshow", checkSession);
  document.addEventListener("visibilitychange", onVisibility);

  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("focus", checkSession);
    window.removeEventListener("pageshow", checkSession);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}
